<template>
  <div v-if="!loading">
    <Singular
      v-if="mostrarSingular"
      :podeEnviarArquivo="inserirAnexo"
      :listaArquivos="listaArquivos"
      @upload-arquivo="uploadArquivo"
      @baixar-arquivo="baixarArquivo"
      @arquivo-para-descricao="abrirModal"
      @abril-Modal-Warn="abrirModalWarn"
    />
    <Analista
      v-else
      :listaArquivos="listaArquivos"
      :codigoUnimed="codigoUnimed"
      :podeEnviarArquivo="inserirAnexo"
      @upload-arquivo="uploadArquivo"
      @reprovar-arquivo="deletarArquivo"
      @baixar-arquivo="baixarArquivo"
      @arquivo-para-descricao="abrirModal"
      @abril-Modal-Warn="abrirModalWarn"
    />
    <ModalAreaTexto
      :value="abrilModal"
      :observacao="observacao"
      :editarSalvar="editarModalDescricao"
      @salvar-modal="salvarDescricao"
      @input="fecharModal"
      @editar-modal="editarModal"
    >
    </ModalAreaTexto>
    <ModalWarn
      :value="abrilModalWarn"
      :mensagemWarn="mensagemWarn"
      @fechar="fecharModalWarn"
    >
    </ModalWarn>
  </div>
  <unicom-spinner
    v-else
    style="min-height: 350px; display: flex; align-items: center"
    v-show="loading"
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
  />
</template>

<script>
/* eslint-disable */
import Singular from "./componentes/Singular/Singular.vue";
import Analista from "./componentes/Analista/Analista.vue";
import { EnumPerfis } from "../../../../../shared/helpers/Enum";
import ModalAreaTexto from "./componentes/Modal/ModalAreaTexto.vue";
import ModalWarn from "./componentes/Modal/ModalWarn/ModalWarn.vue";
import TabAnexosMixin from "./TabAnexosMixin";

export default {
  mixins: [TabAnexosMixin],
  components: {
    Singular,
    Analista,
    ModalAreaTexto,
    ModalWarn
  },
  props: {
    podeAprovarReprovar: {
      type: Boolean
    },
    podeEnviarArquivo: {
      type: Boolean
    },
    codigoUnimed: {
      type: [String, Number]
    }
  },
  data() {
    return {
      abrilModal: false,
      abrilModalWarn: false,
      mensagemWarn: "",
      observacao: "",
      arquivoParaDescricao: [],
      editarModalDescricao: true
    };
  },
  methods: {
    abrirModal(arquivo) {
      console.log("tab_anexo_vue: com o arquivo: ", arquivo);
      this.editarModal(this.editarModalDescricao, arquivo);
      this.observacao = arquivo.descricao;
      this.abrilModal = true;
      this.arquivoParaDescricao = arquivo;
    },
    fecharModal(input) {
      this.abrilModal = input;
    },
    salvarDescricao(descricaoArquivo) {
      console.log("descricaoArquivo", descricaoArquivo);
      var descricaoEstaPopulada = descricaoArquivo.trim().length > 0;
      if (descricaoEstaPopulada) {
        this.salvarDescricaoAnexo(this.arquivoParaDescricao, descricaoArquivo);
        this.abrilModal = false;
      } else {
        this.abrirModalWarn(true, "A descrição não pode ser vazia");
      }
    },
    editarModal(poderEditarModal, arquivo) {
      console.log("editar", this.papelUsuarioMixin.chave, poderEditarModal);     
      if (this.inserirAnexo) {
        // Se o usuario acessando for o mesmo que fez upload do arquivo ou perfil de usuario UBGestorGestaoRedes
        var usuarioTemPermissao = this.nomeUsuarioMixin === arquivo.usuario.nome || this.papelUsuarioMixin.chave === EnumPerfis.ADMINISTRADOR;
        if (usuarioTemPermissao) {
          this.editarModalDescricao = true;
          console.log("this.editarModalDescricao", this.editarModalDescricao);
        } else {
          this.editarModalDescricao = false;
          console.log("this.editarModalDescricao", this.editarModalDescricao);
        }
        console.log("editarif", this.papelUsuarioMixin.chave, poderEditarModal);
      }
    },
    abrirModalWarn(abrir, mensagem) {
      this.abrilModalWarn = abrir;
      this.mensagemWarn = mensagem;
    },
    fecharModalWarn(input) {
      this.abrilModalWarn = input;
    }
  },
  computed: {
    mostrarSingular() {
      return (
        this.papelUsuarioMixin.chave === EnumPerfis.SINGULAR ||
        this.papelUsuarioMixin.chave === EnumPerfis.UB_CONSULTA ||
        this.papelUsuarioMixin.chave === EnumPerfis.FEDERACAO_CONSULTA
      );
    },
    inserirAnexo() {
      return (
        this.papelUsuarioMixin.chave === EnumPerfis.SINGULAR ||
        this.papelUsuarioMixin.chave === EnumPerfis.ADMINISTRADOR ||
        this.papelUsuarioMixin.chave === EnumPerfis.GTR ||
        this.papelUsuarioMixin.chave === EnumPerfis.UB_CONSULTA ||
        this.papelUsuarioMixin.chave === EnumPerfis.FEDERACAO_CONSULTA
      );
    }
  }
};
</script>
